import type { SVGProp } from './types';

export const chevronRight = (props: SVGProp) => (
  <svg
    width={props.width || '28'}
    height={props.height || '28'}
    viewBox="0 0 28 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    {...props}
  >
    <path
      d="m16.3602 13.5269-3.7734-3.76671c-.062-.06249-.1357-.11208-.2169-.14593-.0813-.03385-.1684-.05127-.2564-.05127-.088 0-.1752.01742-.2564.05127-.0812.03385-.155.08344-.2169.14593-.1242.12491-.1939.29391-.1939.47001 0 .1761.0697.3451.1939.47l3.3 3.3333-3.3 3.3c-.1242.1249-.1939.2939-.1939.47 0 .1761.0697.3451.1939.47.0617.063.1353.1131.2166.1475.0812.0343.1685.0522.2567.0525.0882-.0003.1754-.0182.2567-.0525.0812-.0344.1549-.0845.2166-.1475l3.7734-3.7666c.0676-.0625.1216-.1382.1586-.2226.0369-.0843.056-.1754.056-.2674 0-.0921-.0191-.1832-.056-.2675-.037-.0844-.091-.1601-.1586-.2225Z"
      stroke="currentColor"
    />
  </svg>
);
